import React from 'react';
import { Label } from '@atlaskit/form';
import { Flex } from '@atlaskit/primitives';

import { DataClassificationDropdown } from '@atlassian/data-classification-level';

import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { FieldContainer } from '../../common/ui/fields/styled.tsx';
import messages from './messages.tsx';
import type { Props } from './types.tsx';

const DataClassificationField = (props: Props) => {
	const { width, value, onChange, allowedValues, errorMessage, isDisabled, nonEditableReason } =
		props;

	const { formatMessage } = useIntl();
	return (
		<JSErrorBoundary
			id="dataClassificationField"
			packageName="jiraIssueCreateCommons"
			fallback="unmount"
			sendToPrivacyUnsafeSplunk
		>
			<FieldContainer width={width} marginTop={gridSize * 2.25} paddingBottom={gridSize * 2.25}>
				<Label htmlFor="data-classification-dropdown-input" id="data-classification-select">
					<Flex justifyContent="start">{formatMessage(messages.classificationFieldLabel)}</Flex>
				</Label>
				<DataClassificationDropdown
					options={allowedValues}
					value={value}
					onChange={onChange}
					isDisabled={isDisabled}
					disabledTooltipMessage={nonEditableReason?.message}
					errorMessage={errorMessage}
				/>
			</FieldContainer>
		</JSErrorBoundary>
	);
};

export default DataClassificationField;
